"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AssertionError = void 0;
exports.assert = assert;
/**
 * A subclass of `Error` that indicates the failure of an assertion.
 */
class AssertionError extends Error {
  /**
   * @param message Message added to the default error message
   */
  constructor(message) {
    super(`Wrong assertion encountered${message ? `: "${message}"` : ''}!`);
    this.name = 'AssertionError';
  }
}

/**
 * Function that throws {@linkcode AssertionError} (with optional message defined with `errorMessage`) if
 * `condition` is falsy.
 * You can use it to narrow types:
 *
 * ```TypeScript
 * interface Foo {
 *   kind: 'Foo';
 * }
 *
 * interface Bar {
 *   kind: 'Bar';
 * }
 *
 * declare const foobar: Foo | Bar;
 *
 * assert(is<Foo>(foobar, foobar.kind === 'Foo'));
 *
 * // `typeof foobar` is now `Foo`
 * ```
 *
 * @param condition Condition we're asserting isn't falsy
 * @param errorMessage Message for the `AssertionError`
 */
exports.AssertionError = AssertionError;
function assert(condition, errorMessage) {
  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions -- we don't mind here
  if (!condition) {
    throw new AssertionError(errorMessage);
  }
}
//# sourceMappingURL=assert.js.map